import { useTranslation } from 'react-i18next';
import { DEP_LABEL_KEYS } from './constants';
import styles from '../InterventionGraphEditor.module.css';
import { PlacementRuleType } from '../../../api/generated';

interface ConnectorProps {
  depType: PlacementRuleType | undefined;
  // Ids of the nodes this connector joins, so the diagonal branch links can
  // anchor to the exact same point on the node edge.
  fromId?: string;
  toId?: string;
}

export const Connector = ({ depType, fromId, toId }: ConnectorProps) => {
  const { t } = useTranslation();
  const isImmediately = depType === PlacementRuleType.ImmediatelyBefore || depType === PlacementRuleType.ImmediatelyAfter;
  return (
    <div
      className={`${styles.connector} ${isImmediately ? styles.connectorTight : ''}`}
      data-connector-from={fromId}
      data-connector-to={toId}
    >
      <div className={styles.connectorLine} />
      {depType && depType !== PlacementRuleType.First && depType !== PlacementRuleType.Last && (
        <span className={styles.connectorLabel}>{t(DEP_LABEL_KEYS[depType])}</span>
      )}
    </div>
  );
};
